import { Component, ViewChild, ElementRef } from '@angular/core';
import { ImportarContribuintesIptuService } from 'src/app/service/configuracao/importar-contribuintes-iptu.service';
import Swal from 'sweetalert2';
import { getSwal } from 'src/app/utils/swalObject';

@Component({
  selector: 'app-importar-contribuintes-iptu-pagina',
  templateUrl: './importar-contribuintes-iptu-pagina.component.html',
  styleUrls: ['./importar-contribuintes-iptu-pagina.component.scss'],
})
export class ImportarContribuintesIptuPaginaComponent {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  loading = false;
  nomeArquivoSelecionado: string = null;

  constructor(private importarService: ImportarContribuintesIptuService) {}

  onArquivoSelecionado(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) {
      this.nomeArquivoSelecionado = null;
      return;
    }
    const ok =
      file.name.toLowerCase().endsWith('.csv') ||
      file.type === 'text/csv' ||
      file.type === 'application/vnd.ms-excel';
    if (!ok) {
      Swal.fire(
        getSwal(
          'warning',
          'Formato inválido',
          'Selecione um arquivo CSV.',
          'Ok',
          null
        )
      );
      input.value = '';
      this.nomeArquivoSelecionado = null;
      return;
    }
    this.nomeArquivoSelecionado = file.name;
    this.enviarArquivo(file);
    input.value = '';
  }

  abrirSeletorArquivo() {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.click();
    }
  }

  enviarArquivo(file: File) {
    this.loading = true;
    this.importarService.importarArquivo(file).subscribe(
      () => {
        this.loading = false;
        this.nomeArquivoSelecionado = null;
        Swal.fire(
          getSwal(
            'success',
            'Sucesso',
            'Arquivo enviado para processamento.',
            'Ok',
            null
          )
        );
      },
      (err) => {
        this.loading = false;
        const msg =
          err &&
          err.error &&
          err.error.excecao &&
          err.error.excecao.recomendacao
            ? err.error.excecao.recomendacao
            : 'Não foi possível concluir a importação. Verifique o arquivo e tente novamente.';
        Swal.fire(getSwal('error', 'Ops!', msg, 'Ok', null));
      }
    );
  }

  /**
   * Modelo gerado no cliente: não chama API para evitar 401 em endpoint inexistente
   * (o interceptor desloga o usuário em qualquer 401).
   * Quando existir GET estável (ex.: /importacoes/contribuintes-iptu/modelo), pode-se
   * voltar a buscar no servidor antes do fallback local.
   */
  baixarModelo() {
    this.baixarModeloLocal();
  }

  private baixarModeloLocal() {
    const bom = '\uFEFF';
    const cabecalho =
      'CPF/CNPJ;Nome;E-mail;Número da inscrição do imóvel;CEP do imóvel;Logradouro;Número do imóvel;Complemento do endereço';
    const linhaExemplo =
      '12.345.678/0001-90;CONTRIBUINTE EXEMPLO LTDA;exemplo@contribuinte.com.br;1234567890;12345-678;Rua das Flores;100;Sala 2';
    const csv = bom + [cabecalho, linhaExemplo].join('\n') + '\n';
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    this.dispararDownloadBlob(blob, 'modelo_importacao_iptu.csv');
  }

  private dispararDownloadBlob(blob: Blob, nomeArquivo: string) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nomeArquivo;
    a.click();
    URL.revokeObjectURL(url);
  }
}
